/**
 * Lunaradesire Theme JavaScript
 * Turkish Lingerie E-commerce - Interactive Features
 */

(function() {
  'use strict';

  // ===== MOBILE MENU =====
  function initMobileMenu() {
    const menuToggle = document.querySelector('[data-mobile-menu-toggle]');
    const menuClose = document.querySelector('[data-mobile-menu-close]');
    const mobileMenu = document.querySelector('[data-mobile-menu]');

    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', function() {
        mobileMenu.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
      });
    }

    if (menuClose && mobileMenu) {
      menuClose.addEventListener('click', function() {
        mobileMenu.classList.add('hidden');
        document.body.style.overflow = '';
      });
    }
  }

  // ===== SEARCH MODAL =====
  function initSearchModal() {
    const searchToggle = document.querySelector('[data-search-toggle]');
    const searchClose = document.querySelector('[data-search-close]');
    const searchModal = document.querySelector('[data-search-modal]');

    if (searchToggle && searchModal) {
      searchToggle.addEventListener('click', function() {
        searchModal.classList.remove('hidden');
        const searchInput = searchModal.querySelector('.search-input');
        if (searchInput) {
          searchInput.focus();
        }
      });
    }

    if (searchClose && searchModal) {
      searchClose.addEventListener('click', function() {
        searchModal.classList.add('hidden');
      });
    }

    // Close modal on overlay click
    if (searchModal) {
      searchModal.addEventListener('click', function(e) {
        if (e.target === searchModal) {
          searchModal.classList.add('hidden');
        }
      });
    }

    // Predictive Search
    const searchInput = document.querySelector('.search-input');
    const searchResults = document.querySelector('[data-search-results]');

    if (searchInput && searchResults) {
      let searchTimeout;
      
      searchInput.addEventListener('input', function(e) {
        const query = e.target.value.trim();
        
        clearTimeout(searchTimeout);
        
        if (query.length < 2) {
          searchResults.innerHTML = '';
          return;
        }

        searchTimeout = setTimeout(function() {
          fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`)
            .then(response => response.json())
            .then(data => {
              if (data.resources && data.resources.results && data.resources.results.products) {
                displaySearchResults(data.resources.results.products);
              }
            })
            .catch(error => console.error('Search error:', error));
        }, 300);
      });

      function displaySearchResults(products) {
        if (!products || products.length === 0) {
          searchResults.innerHTML = '<p class="text-sm text-gray-500 p-4">Ürün bulunamadı</p>';
          return;
        }

        const html = products.map(product => `
          <a href="${product.url}" class="search-result-item flex gap-3 p-3 hover:bg-gray-50 transition-colors">
            <img src="${product.image}" alt="${product.title}" class="w-16 h-16 object-cover rounded">
            <div class="flex-1">
              <p class="font-medium text-sm">${product.title}</p>
              <p class="text-sm text-primary font-semibold">${product.price}</p>
            </div>
          </a>
        `).join('');

        searchResults.innerHTML = html;
      }
    }
  }

  // ===== CART DRAWER =====
  // Make cart functions globally accessible
  window.openCartDrawer = function() {
    const cartOverlay = document.querySelector('[data-cart-overlay]');
    const cartPanel = document.querySelector('[data-cart-panel]');
    if (cartOverlay) {
      cartOverlay.classList.remove('hidden');
      cartOverlay.style.display = 'block';
    }
    if (cartPanel) {
      cartPanel.classList.remove('hidden');
      cartPanel.style.display = 'flex';
    }
    document.body.style.overflow = 'hidden';
  };

  window.closeCartDrawer = function() {
    const cartOverlay = document.querySelector('[data-cart-overlay]');
    const cartPanel = document.querySelector('[data-cart-panel]');
    if (cartOverlay) {
      cartOverlay.classList.add('hidden');
      cartOverlay.style.display = 'none';
    }
    if (cartPanel) {
      cartPanel.classList.add('hidden');
      cartPanel.style.display = 'none';
    }
    document.body.style.overflow = '';
  };

  function initCartDrawer() {
    const cartButtons = document.querySelectorAll('[data-cart-toggle]');
    const cartOverlay = document.querySelector('[data-cart-overlay]');
    const cartPanel = document.querySelector('[data-cart-panel]');
    const cartClose = document.querySelectorAll('[data-cart-close]');

    // Ensure cart is closed on page load
    window.closeCartDrawer();

    cartButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        window.openCartDrawer();
      });
    });

    cartClose.forEach(button => {
      button.addEventListener('click', function() {
        window.closeCartDrawer();
      });
    });

    if (cartOverlay) {
      cartOverlay.addEventListener('click', window.closeCartDrawer);
    }

    // Close cart with ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && cartPanel && !cartPanel.classList.contains('hidden')) {
        window.closeCartDrawer();
      }
    });

    // Refresh cart on page load
    refreshCart();
  }

  // ===== CART FUNCTIONS =====
  function refreshCart() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        updateCartCount(cart.item_count);
      })
      .catch(error => console.error('Cart refresh error:', error));
  }

  function updateCartCount(count) {
    const cartCounts = document.querySelectorAll('.cart-count');
    cartCounts.forEach(element => {
      if (count > 0) {
        element.textContent = count;
        element.style.display = 'flex';
      } else {
        element.style.display = 'none';
      }
    });
  }

  window.updateCartDrawerQuantity = function(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(data => {
      window.location.reload();
    })
    .catch(error => {
      console.error('Error updating cart:', error);
    });
  };

  window.removeFromCartDrawer = function(line) {
    updateCartDrawerQuantity(line, 0);
  };

  // ===== HERO CAROUSEL =====
  function initHeroCarousel() {
    const carousel = document.querySelector('[data-carousel]');
    if (!carousel) return;

    const slides = carousel.querySelectorAll('[data-slide]');
    const prevBtn = document.querySelector('.carousel-prev');
    const nextBtn = document.querySelector('.carousel-next');
    const dots = document.querySelectorAll('.carousel-dot');

    if (slides.length <= 1) return;

    let currentSlide = 0;
    let autoplayInterval;

    function showSlide(index) {
      slides.forEach((slide, i) => {
        slide.style.display = i === index ? 'block' : 'none';
      });

      dots.forEach((dot, i) => {
        if (i === index) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });

      currentSlide = index;
    }

    function nextSlide() {
      const next = (currentSlide + 1) % slides.length;
      showSlide(next);
    }

    function prevSlide() {
      const prev = (currentSlide - 1 + slides.length) % slides.length;
      showSlide(prev);
    }

    function startAutoplay() {
      autoplayInterval = setInterval(nextSlide, 5000);
    }

    function stopAutoplay() {
      clearInterval(autoplayInterval);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        stopAutoplay();
        prevSlide();
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        stopAutoplay();
        nextSlide();
        startAutoplay();
      });
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', function() {
        stopAutoplay();
        showSlide(index);
        startAutoplay();
      });
    });

    // Initialize
    showSlide(0);
    startAutoplay();

    // Pause on hover
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
  }

  // ===== WISHLIST =====
  window.toggleWishlist = function(productId) {
    // Get existing wishlist from localStorage
    let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
    
    if (wishlist.includes(productId)) {
      wishlist = wishlist.filter(id => id !== productId);
      console.log('Removed from wishlist:', productId);
    } else {
      wishlist.push(productId);
      console.log('Added to wishlist:', productId);
    }
    
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
    
    // Update UI if needed
    updateWishlistUI();
  };

  function updateWishlistUI() {
    const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
    // Update heart icons based on wishlist state
    document.querySelectorAll('[data-product-id]').forEach(element => {
      const productId = element.dataset.productId;
      if (wishlist.includes(parseInt(productId))) {
        element.classList.add('active');
      } else {
        element.classList.remove('active');
      }
    });
  }

  // ===== PRODUCT QUANTITY =====
  function initProductQuantity() {
    const quantityInputs = document.querySelectorAll('.quantity-input');
    
    quantityInputs.forEach(input => {
      input.addEventListener('change', function() {
        const value = parseInt(this.value);
        if (value < 1 || isNaN(value)) {
          this.value = 1;
        }
      });
    });
  }

  // ===== INITIALIZE ON DOM READY =====
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initMobileMenu();
    initSearchModal();
    initCartDrawer();
    initHeroCarousel();
    initProductQuantity();
    updateWishlistUI();
  }

  // Add to cart notification
  if (document.querySelector('.product-form')) {
    document.querySelector('.product-form').addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(this);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Show success message or update cart
        refreshCart();
        
        // Open cart drawer
        const cartOverlay = document.querySelector('[data-cart-overlay]');
        const cartPanel = document.querySelector('[data-cart-panel]');
        if (cartOverlay) cartOverlay.classList.remove('hidden');
        if (cartPanel) cartPanel.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
      })
      .catch(error => {
        console.error('Add to cart error:', error);
        alert('Ürün sepete eklenirken bir hata oluştu.');
      });
    });
  }

})();
